import { createUseStyles } from 'react-jss'
import { colors } from '../../common/colors'

export const style = {
  key: {
    minWidth: 170,
    maxWidth: 220,
    display: 'flex',
    flexDirection: 'column',
    fontSize: 11,
    backgroundColor: colors.backgroundGray,
    padding: '6px 10px',
    border: `1px solid ${colors.silver}`,
    borderRadius: 6
  },
  title: {
    lineHeight: 1.2,
    textTransform: 'uppercase',
    fontWeight: 'bold',
    overflowY: 'hidden'
  },
  labels: {
    position: 'relative'
  },
  labelLeft: {
    width: '100%',
    textAlign: 'left'
  },
  labelCenter: {
    width: '100%',
    textAlign: 'center',
    position: 'absolute',
    top: 0
  },
  labelRight: {
    width: '100%',
    textAlign: 'right',
    position: 'absolute',
    top: 0
  },
  scale: {
    width: '100%',
    height: 15
  },
  scaleBox: {
    width: 15,
    height: 15
  },
  note: {
    marginTop: 7,
    lineHeight: 1.2,
    color: '#999',
    textTransform: 'none',
    fontStyle: 'italic'
  }
}

export const useStyles = createUseStyles(style)
